// extracted by mini-css-extract-plugin
export var lg = "_ib-7";
export var md = "_ib-6";
export var placeholderContainer = "_ib-1";
export var placeholderIcon = "_ib-2";
export var productImage = "_ib-0";
export var sm = "_ib-5";
export var xl = "_ib-8";
export var xs = "_ib-4";
export var xxs = "_ib-3";